import { render, staticRenderFns } from "./UnboxBoxElement.vue?vue&type=template&id=f2e9591e&scoped=true"
import script from "./UnboxBoxElement.vue?vue&type=script&lang=js"
export * from "./UnboxBoxElement.vue?vue&type=script&lang=js"
import style0 from "./UnboxBoxElement.vue?vue&type=style&index=0&id=f2e9591e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e9591e",
  null
  
)

export default component.exports